<template>
  <!-- アカウント登録 -->
  <div class="link-to-account">
    <div class="message" v-show="!userInfoStore.userSnsInfo.length">
      <p>案件に応募するためにはSNS登録が必要です</p>
    </div>
    <div
      v-for="(sns, index) in MEDIA_NAME"
      :key="index"
      @click="!loading ? linkToAccount(index) : ''"
      class="list__item"
    >
      <p>{{ sns }}</p>
      <img
        class="detail_icon"
        src="../assets/check.svg"
        align="right"
        v-if="isRegistered(index)"
      />
      <img class="check_icon" src="../assets/detail.svg" align="right" v-else />
    </div>
  </div>
  <div class="button-area">
    <common-button
      :data="{
        status: !loading ? 0 : 2,
        button: `案件詳細に戻る`,
      }"
      @click="Comfirm()"
      v-if="
        userInfoStore.isRegistFromProjectDetail.show &&
        userInfoStore.addressInfo.id > 0
      "
    ></common-button>
    <common-button
      :data="{
        status: !loading ? 0 : 2,
        button: `次へ`,
      }"
      @click="Comfirm()"
      v-if="
        userInfoStore.isRegistFromProjectDetail.show &&
        userInfoStore.addressInfo.id < 0
      "
    ></common-button>
  </div>
  <sns-account-dialog
    ref="dialog"
    v-model="showDialog"
    :media-type="selectedMediaType"
    :account-name="accountName"
  ></sns-account-dialog>
  <comfirm-dialog
    ref="comfirmDialog"
    v-model="showComfirmDialog"
    :sub-message="subMessage"
    :message="message"
    :button="userInfoStore.addressInfo.id > 0 ? `案件詳細に戻る` : `次へ`"
    @apply="
      userInfoStore.addressInfo.id > 0 ? backToProjectDetail() : pushAddress()
    "
  ></comfirm-dialog>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from "vue";
import { MEDIA_NAME } from "../consts/common";
import SnsAccountDialog from "../components/SnsAccountDialog.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import router from "../router";
import CommonButton from "./CommonButton.vue";
import ComfirmDialog from "./ComfirmDialog.vue";

const showDialog = ref(false);
const showComfirmDialog = ref(false);
const accountName = ref("");
const selectedMediaType = ref(-1);
const dialog = ref<InstanceType<typeof SnsAccountDialog>>();
const comfirmDialog = ref<InstanceType<typeof ComfirmDialog>>();
const userInfoStore = UserInfoStore();
const loading = ref(true);
const message = ref("");
const subMessage = ref("");

function linkToAccount(index: number) {
  selectedMediaType.value = index;
  const data = userInfoStore.userSnsInfo.find((v) => v.media_type == index);
  if (data) {
    accountName.value = data.account_name;
  } else {
    accountName.value = "";
  }
  showDialog.value = true;
  dialog.value?.openDialog();
}
onMounted(async () => {
  document.title = "SNSアカウント登録";
  subMessage.value = `案件${
    userInfoStore.isRegistFromProjectDetail.title
  }\nの応募に必要な${
    MEDIA_NAME[userInfoStore.isRegistFromProjectDetail.mediaType]
  }アカウントの登録が済んでいません。`;
  if (userInfoStore.addressInfo.id > 0) {
    message.value = `案件詳細に戻ってよろしいですか`;
  } else {
    message.value = `配送先住所登録に進みます、よろしいですか`;
  }
  // SNSユーザー情報取得
  await userInfoStore.getUserSnsAccount();
  await nextTick();
  loading.value = false;
});
function isRegistered(index: number) {
  if (!userInfoStore.userSnsInfo) return false;
  else {
    const data = userInfoStore.userSnsInfo.find(
      (v) =>
        v.media_type == index
    );
    if (data) return true;
    else return false;
  }
}
// 案件詳細に戻る もしくは 次へ（配送先住所登録）
function Comfirm() {
  // 遷移元の案件のsnsアカウント登録がされていない場合は確認ダイアログを出す
  if (
    !userInfoStore.userSnsInfo.find(
      (v) => v.media_type == userInfoStore.isRegistFromProjectDetail.mediaType
    )
  ) {
    showComfirmDialog.value = true;
    comfirmDialog.value?.openDialog();
    // 配送先住所登録がまだの場合は配送先住所登録画面に遷移する
  } else if (
    userInfoStore.isRegistFromProjectDetail.show &&
        userInfoStore.addressInfo.id < 0
  ) {
    pushAddress()
  } else {
    userInfoStore.setIsRegistFromProjectDetail({
      show: false,
      title: "",
      mediaType: -1,
    });
    router.replace("/project-detail");
  }
}

// 案件詳細に戻る
function backToProjectDetail() {
  showComfirmDialog.value = false;
  userInfoStore.setIsRegistFromProjectDetail({
    show: false,
    title: "",
    mediaType: -1,
  });
  router.replace("/project-detail");
}

// 配送先住所登録へ
function pushAddress() {
  router.replace("/address");
}
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/mixin.scss";
.link-to-account {
  // position: relative;
  @include container();
  padding-top: 16px;
  background-color: #f3f4f5;
  overflow: auto;
}
.link-to-account::-webkit-scrollbar {
  display: none;
}
.message {
  width: 300px;
  // height: 52px;
  text-align: center;
  margin: 0 auto 16px auto;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  background: $white;
  border: 1px solid $OMOT_COLOR;
  border-radius: 2px;
  p {
    font-size: $FONT_SIZE_S;
    color: $OMOT_COLOR;
  }
}
img {
  padding-right: 10px;
}
.check-icoin {
  filter: brightness(0) saturate(100%) invert(22%) sepia(98%) saturate(1964%)
    hue-rotate(188deg) brightness(99%) contrast(94%);
}
.list__item {
  @include menu-list-item();
}
.button-area {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  text-align: center;
  display: block;
  position: fixed;
  bottom: 80px;
  font-size: $FONT_SIZE_M;
  line-height: 21px;
  padding-top: 10px;
  // width: 200px;
  margin: 0 auto;
}
</style>
